import {z} from 'zod';
import {PromptToCardAgentStatus} from '../promptToCardAgent/promptToCardAgent';
import {MacroItemTypeValue} from 'common/src/modules/macros/macros.types';
import {AiConditionOperator} from './cardDetailsV2/aiModels/cardDetailsAI.enums';

export const responseSchema = z.object({
  status: z
    .enum([PromptToCardAgentStatus.AddOrUpdate, PromptToCardAgentStatus.NoAction])
    .describe(
      'The status of the agent, in case of failure, return noAction, otherwise return addOrUpdate',
    ),
  chainOfThoughts: z.string().describe('The chain of thoughts of the agent'),
});

export const conditionOutputSchema = z.object({
  textValues: z
    .array(z.string())
    .optional()
    .describe(
      `Array of textual values that will be used to evaluate the condition. Values should be provided if the condition condKeyType is ${MacroItemTypeValue.Text} or ${MacroItemTypeValue.TextList}`,
    ),
  numericValues: z
    .array(z.number())
    .optional()
    .describe(
      `Array of numeric values that will be used to evaluate the condition. Values should be provided if the condition condKeyType is ${MacroItemTypeValue.Numeric}`,
    ),
  booleanValue: z
    .boolean()
    .optional()
    .describe(
      `Boolean value that will be used to evaluate the condition. Values should be provided if the condition condKeyType is ${MacroItemTypeValue.Condition}`,
    ),
  dateValues: z
    .array(z.string())
    .optional()
    .describe(
      `Array of date values that will be used to evaluate the condition, in ISO format. Values should be provided if the condition condKeyType is ${MacroItemTypeValue.Date} or ${MacroItemTypeValue.DateList}`,
    ),
  datesRange: z
    .object({from: z.string(), to: z.string()})
    .optional()
    .describe(
      `Range of date values that will be used to evaluate the condition, in ISO format. Values should be provided if the condition condKeyType is ${MacroItemTypeValue.DateRange}`,
    ),
  numbersRange: z
    .object({from: z.number(), to: z.number()})
    .optional()
    .describe(`Range of numeric values that will be used to evaluate the condition.`),
});

export const compoundConditionRuleSchema = z.object({
  signal: z.object({
    name: z.string().describe('The display name of the signal'),
    value: z.string().describe('The signal key/value identifier'),
    categories: z
      .array(z.number())
      .optional()
      .nullable()
      .describe('The condition categories this signal belongs to'),
  }),
  ruleOperator: z.nativeEnum(AiConditionOperator).describe('The operator to apply for this rule'),
  ruleValue: conditionOutputSchema.describe(
    'The value(s) to evaluate the rule against, based on signal type',
  ),
});

export const compoundConditionSectionSchema = z.object({
  rules: z
    .array(compoundConditionRuleSchema)
    .describe('Rules within a section are evaluated with OR logic'),
});

export const compoundConditionOutputSchema = z.object({
  name: z.string().describe('The display name of the output'),
  sections: z
    .array(compoundConditionSectionSchema)
    .describe('Sections within an output are evaluated with AND logic'),
});
